import './index.scss';

export function Loading(): JSX.Element {
  return (
    <div className='loading' role='loading'>
      <img src='/images/loader.gif' className='loading-icon' />
    </div>
  );
}
